import React from "react";
import { Typography, useTheme } from "@mui/material";
import { StatusTone } from "./types";
import { MONO_FONT } from "@/shared/typography";

interface StatusLineProps {
  children: React.ReactNode;
  tone?: StatusTone;
}

export function StatusLine({ children, tone = "neutral" }: StatusLineProps) {
  const theme = useTheme();
  
  const getColorForTone = (tone: StatusTone): string => {
    switch (tone) {
      case "ok":
        return theme.palette.success.main;
      case "warn":
        return theme.palette.warning.main;
      case "error":
        return theme.palette.error.main;
      case "accent":
        return theme.palette.primary.main;
      case "neutral":
      default:
        return theme.palette.text.disabled;
    }
  };

  return (
    <Typography
      component="span"
      role="status"
      sx={{
        fontFamily: MONO_FONT,
        letterSpacing: "0.12em",
        fontSize: 10,
        color: getColorForTone(tone),
      }}
    >
      {children}
    </Typography>
  );
}